import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	container: {
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		backgroundColor: tokens.colorNeutralBackground1,
		boxShadow: '0 0 2px rgba(0, 0, 0, 0.12) 0 2px 4px rgba(0, 0, 0, 0.14)',
		...shorthands.margin('5px', 0),
	},
	dismissBtn: {
		marginLeft: 'auto !important',
	},
});

export default useStyles;
